<div class="page-password-recovery">
  <h1 class="text-center mb-4">{{ 'restorePwd.passwordRecovery' | transloco }}</h1>

  <form class="local-acc-form" [formGroup]="form" (submit)="onSend()">
    <app-notification #notification [hidden]="!notification?.isShow" class="w-100"></app-notification><br />

    <mat-form-field class="email-form-field mb-3" appearance="fill" class="col-12">
      <mat-label>{{ 'restorePwd.email' | transloco }}</mat-label>
      <input data-test="password-recovery_input-email" matInput formControlName="email" />
      <mat-error *ngIf="form.get('email')?.hasError('required')">{{ 'restorePwd.emailRequiredError' | transloco }}</mat-error>
    </mat-form-field>

    <p>{{ 'restorePwd.info' | transloco }}</p>

    <div class="col-12">
      <dnt-captcha #appDntCaptcha [apiUrl]="captchaApiUrl" data-test="password-recovery-captcha"></dnt-captcha>
      <div class="info">
        <mat-error class="translate" *ngIf="!!errorMessage">{{ errorMessage }}</mat-error>
      </div>
    </div>

    <button type="submit" class="btn-send xl w-100 mt-2 mb-4" color="primary" mat-flat-button data-test="password-recovery_btn-send">
      {{ 'restorePwd.send' | transloco }}
    </button>
  </form>
</div>
